import { render, staticRenderFns } from "./AffirmDistributionBook.vue?vue&type=template&id=e75e5f4a&"
import script from "./AffirmDistributionBook.vue?vue&type=script&lang=js&"
export * from "./AffirmDistributionBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports